import type { FC } from "react"

import { LongWordWrapper } from "@/components/table/LongWordWrapper"
import TableCellWithId from "@/screens/ManageProducts/components/Instructions/components/tables/TableCellWithId"

interface SupplierNameCellProps {
  companyName?: string | null
  externalSystemId?: string | null
}

export const SupplierNameCell: FC<SupplierNameCellProps> = ({ companyName, externalSystemId }) => {
  return (
    <TableCellWithId id={externalSystemId}>
      <LongWordWrapper>{companyName}</LongWordWrapper>
    </TableCellWithId>
  )
}
